(function ($) {
  $(function () {

    var sidebar = $(".js-faq-sidebar");


    if (sidebar.length && $(window).width() > 1200) {

      var lastScrollTop = 0;
      $(document).scroll(function (e) {

        var container = $(".section__faq-qas");
        var sideBarBottom = sidebar.offset().top + sidebar.outerHeight();
        var containerBottom = container.offset().top + container.outerHeight();
        var fixedToTop = "is-fixed-to-top";
        var fixedToBottom = "is-fixed-to-bottom";
        var scrollTop = $(this).scrollTop();
        var viewportBottom = $(window).scrollTop() + $(window).height();



        if (window.scrollY < 1025) {
          sidebar.removeClass(fixedToTop);
        }

        if (sideBarBottom >= containerBottom && scrollTop > lastScrollTop) {
          sidebar.removeClass(fixedToTop).addClass(fixedToBottom);
        } else if (window.scrollY > 1025 && scrollTop > lastScrollTop && !sidebar.hasClass("is-fixed-to-bottom")) {
          sidebar.addClass(fixedToTop);
        } else if (scrollTop < lastScrollTop && sidebar.hasClass("is-fixed-to-bottom") && viewportBottom <= sideBarBottom) {
          sidebar.removeClass(fixedToBottom).addClass(fixedToTop);
        }
        lastScrollTop = scrollTop;
      });
    }


  });
})(jQuery);
